module.exports = {
  __depends__: [ require(327), require(392) ],
  __init__: [ 'bendpoints', 'bendpointSnapping' ],
  bendpoints: [ 'type', require(308) ],
  bendpointMove: [ 'type', require(305) ],
  connectionSegmentMove: [ 'type', require(309) ],
  bendpointSnapping: [ 'type', require(306) ]
};
